var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-content"},_vm._l((_vm.contacts),function(contact){return _c('contactItem',{key:contact.uid,attrs:{"contact":contact},on:{"jump-to-profile":function($event){return _vm.$emit('jump-to-profile',contact.uid)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }